import React, { useState } from "react";
import { ButtonDropNav } from "@ufginsurance/ui-kit";
import ConfirmationModal from "../../../components/modal/ConfirmationModal";
import { useSubmissionActions } from "./useSubmissionActions";

import "./SubmissionsListActions.scss";

const SubmissionsListActions = ({ quote, afterWithdraw }) => {
  const [withdrawnConfirmation, setWithdrawnConfirmation] = useState(false);

  const { handleWithdraw, withdrawing } = useSubmissionActions({
    quote,
    afterWithdraw
  });

  const disabled = quote.status === "Not Taken";

  return (
    <div className="oq__submissions-list__actions__container">
      <ButtonDropNav
        className="oq__submissions-list__actions__trigger"
        id="menu1"
        buttonText="..."
        variant="primary"
        disabled={disabled}
        links={[
          {
            text: "Withdraw",
            onClick: () => setWithdrawnConfirmation(true)
          }
        ]}
      >
        ...
      </ButtonDropNav>

      <ConfirmationModal
        handleClose={() => setWithdrawnConfirmation(false)}
        handleConfirm={async () => {
          await handleWithdraw();
          setWithdrawnConfirmation(false);
        }}
        title="Withdraw Submission"
        message="Are you sure you want to withdraw this submission?"
        show={withdrawnConfirmation}
        altCloseMethod={!withdrawing}
        closeIcon={!withdrawing}
        cancelText="Cancel"
        confirmText="Withdraw Quote"
        confirmVariant="tertiary"
        confirmSpinner={withdrawing}
        confirmDisabled={withdrawing}
        cancelDisabled={withdrawing}
      />
    </div>
  );
};

export default SubmissionsListActions;
